import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  forwardRef,
  OnDestroy,
} from '@angular/core';
import { SelectItem } from 'primeng/api';
import { SubSink } from 'subsink';
import { UserSelectorService } from './services/user-selector.service';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { finalize } from 'rxjs';
import { AutoCompleteCompleteEvent } from 'primeng/autocomplete';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'mnc-user-selector',
  templateUrl: './user-selector.component.html',
  styleUrls: ['./user-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => UserSelectorComponent),
      multi: true,
    },
  ],
  standalone: false,
})
export class UserSelectorComponent implements OnDestroy, ControlValueAccessor {
  private subs = new SubSink();
  private onChange: (value: any) => void;
  private onTouched: () => void;

  value?: SelectItem;
  disabled = false;
  suggestions: SelectItem[] = [];

  constructor(
    private userSelectorService: UserSelectorService,
    private ref: ChangeDetectorRef
  ) {}

  loadUsers(event: AutoCompleteCompleteEvent): void {
    this.subs.sink = this.userSelectorService
      .getUsers(event.query)
      .pipe(finalize(() => this.ref.markForCheck()))
      .subscribe((items) => (this.suggestions = items));
  }

  registerOnChange(fn: (value: any) => any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  onClear() {
    this.value = null;
    this.onChange(null);
  }

  selectUser(item: SelectItem): void {
    this.value = item;
    this.onChange(item.value);
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
    this.ref.detectChanges();
  }

  writeValue(value: string): void {
    if (value === null) return;
    this.value = { value, label: value };
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
